import { ReactNode } from 'react';

import { ButtonIcon, Flex } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type TJournalFormHeader = {
  onCancel: () => void;
  children: ReactNode;
};

export const JournalFormHeader = ({
  onCancel,
  children,
}: TJournalFormHeader) => (
  <Flex justifyContent="space-between" alignItems="center" mb={2}>
    {children}
    <ButtonIcon aria-label="close modal" onClick={onCancel}>
      <Icon
        name={iconNames.cross}
        width="12px"
        height="12px"
        stroke="var(--fgPrimary)"
      />
    </ButtonIcon>
  </Flex>
);
